import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { PreferencesResponse } from "./models";

const getPreferences = async (): Promise<PreferencesResponse> => {
    let config = getConfig();
    try {
        const response = await axios.get<PreferencesResponse>(`/admin/preferences`, config);
        return response.data;

    } catch (error) {
        return error as any;
    }
};

const updatePreferences = async (preferences: FormData): Promise<PreferencesResponse> => {
    let config = getConfig(preferences);
    try {
        const response = await axios.patch(`/admin/preferences`, preferences, config);
        return response.data;
    } catch (error) {
        return error as any;
    }
};

export { getPreferences, updatePreferences };